module.exports = __webpack_public_path__ + "static/media/S (134).3ec31e5a.jpg";